export default __webpack_public_path__ + "static/media/goal.d0941b76.svg";